/**
 * Specifies the CSS class that will be applied to the cells of the timeline area
 * @param instance
 * @returns {(function(*): (string|string))|*}
 */
export default instance => (task, date) => {
  const zoomInDays = instance.config.durationData.mode === 'day';
  const zoomInHours = instance.config.durationData.mode === 'hour';

  if (zoomInDays && !instance.isWorkDay(date, instance.getCalendar(task.gantt_id))) {
    if (task.type === instance.config.types.button || !task.gantt_id) {
      return '';
    }

    return 'weekend';
  }

  if (zoomInHours && !instance.isWorkTime({ date, task, unit: instance.config.duration_unit })) {
    return 'weekend';
  }

  return '';
};
